<!-- StepNotation.vue -->
<template>
    <div class="modal_visard">
      <div class="modal_main_inputs_head">
        Выберите нотацию для визуализации бизнес-процесса
      </div>
      
      <div class="modal_visard_cards">
        <div class="modal_visard_card"
             v-for="(card, index) in localCards" 
             :key="index"
             :class="{ modal_visard_card_active: card.active }"
             @click="selectCard(index)">
          <div class="modal_visard_card_head">{{ card.head }}</div>
          <br><br>
          <div class="modal_visard_card_content">{{ card.text }}</div>
        </div>
      </div>
      
      <br><br>
      
      <!-- Информация о выбранной нотации -->
      <div class="modal_visard_cards_info" v-if="activeCardInfo">
        <div class="modal_visard_cards_info_head">{{ activeCardInfo.head }}</div>
        <div class="modal_visard_cards_info_content">{{ activeCardInfo.content }}</div>
        <div class="modal_visard_cards_info_footer">{{ activeCardInfo.footer }}</div>
      </div>
      
      <!-- Заглушка -->
      <div class="modal_visard_cards_info" v-else>
        <div class="modal_visard_cards_info_head">Выберите нотацию</div>
        <div class="modal_visard_cards_info_content">
          Нажмите на одну из карточек выше, чтобы увидеть информацию
        </div>
        <div class="modal_visard_cards_info_footer"></div>
      </div>
      
      <br><br>
      
      <!-- Кнопка продолжения (активна только если выбрана нотация) -->
      <div class="modal_main_load_content_btn" 
           @click="$emit('continue')"
           :class="{ 'disabled': !hasSelection }"
           style="cursor: pointer; width: 100%; max-width: none;">
        <span>Продолжить</span>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'StepNotation',
    props: {
      cards: {
        type: Array,
        required: true,
        validator(value) {
          return value.every(card => 
            card.head && 
            card.text && 
            typeof card.active === 'boolean' &&
            Array.isArray(card.info)
          )
        }
      }
    },
    emits: ['update:cards', 'select', 'continue'],
    computed: {
      localCards: {
        get() {
          return this.cards
        },
        set(value) {
          this.$emit('update:cards', value)
        }
      },
      activeCardInfo() {
        const activeCard = this.cards.find(card => card.active)
        return activeCard?.info?.[0] || null
      },
      hasSelection() {
        return this.cards.some(card => card.active)
      }
    },
    methods: {
      selectCard(selectedIndex) {
        const updatedCards = this.cards.map((card, index) => ({
          ...card,
          active: index === selectedIndex
        }))
        this.localCards = updatedCards
        this.$emit('select', selectedIndex)
      }
    }
  }
  </script>
  
  <style scoped>
  .modal_main_inputs_head {
    text-align: start;
    margin-bottom: 24px;
    font-size: 18px;
  }
  
  .modal_visard_cards {
    display: flex;
    justify-content: space-between;
    gap: 8px;
    flex-wrap: wrap;
  }
  
  .modal_visard_card {
    user-select: none;
    cursor: pointer;
    background: transparent;
    border: 1px solid #403F6D;
    display: flex;
    justify-content: start;
    align-items: center;
    flex-direction: column;
    padding: 32px 16px;
    border-radius: 23px;
    width: calc(25% - 6px);
    transition: all 0.3s;
  }
  
  .modal_visard_card:hover {
    border-color: #8A75FF;
    background: #8a75ff1a;
  }
  
  .modal_visard_card_active {
    border: 1px solid #FF00E1;
    background: #c572ba13;
  }
  
  .modal_visard_card_head {
    font-size: 24px;
    font-weight: bold;
    color: #8A75FF;
  }
  
  .modal_visard_card_content {
    font-size: 12px;
    color: #888;
    text-align: center;
  }
  
  .modal_visard_cards_info {
    user-select: none;
    background: transparent;
    border: 1px solid #403F6D;
    display: flex;
    justify-content: start;
    align-items: start;
    flex-direction: column;
    padding: 32px;
    border-radius: 23px;
    width: 100%;
    gap: 16px;
    transition: all 0.3s;
  }
  
  .modal_visard_cards_info div {
    text-align: start;
    width: 100%;
  }
  
  .modal_visard_cards_info_head {
    font-size: 18px;
    font-weight: 600;
  }
  
  .modal_visard_cards_info_content {
    color: #8E8D8F;
    line-height: 1.6;
  }
  
  .modal_visard_cards_info_footer {
    color: #8A75FF;
    font-size: 14px;
  }
  
  .modal_main_load_content_btn {
    display: flex;
    gap: 8px;
    padding: 18px 40px;
    background: #8A75FF;
    justify-content: center;
    border-radius: 24px;
    cursor: pointer;
    transition: opacity 0.3s;
  }
  
  .modal_main_load_content_btn:hover {
    opacity: 0.9;
  }
  
  .modal_main_load_content_btn.disabled {
    opacity: 0.5;
    pointer-events: none;
  }
  
  @media (max-width: 768px) {
    .modal_visard_cards {
      flex-direction: column;
    }
    
    .modal_visard_card {
      width: 100%;
    }
  }
  </style>